import React from 'react'
export const HindiCanvas = ({ user, score, type, boothDetails, isScoreShow, title }) => {
    if (type && type == 'karyakarta') {
        return (
            <div className="cert_center" id="generate_canvas_div">
                <div className="cert_content_position">
                    <img src="/assets/images/kamal.png" className="kamal"/>
                    <div className="cert_content">
                        <img src="/assets/images/modi.png" alt="" />

                        <h5 className="nm_can_name">
                            Narendra <span>Modi</span>
                        </h5>

                        <h2 className="cong_canvas_hi">वन्दे मातरम</h2>
                        <h3 className="volnt_name_hi">
                            <span>प्रिय </span>{user}
                        </h3>

                        <h6 className="volnt_g_eff_hi">आपने <span className="mkb_qz_h2_hi">{title || "'मन की बात क्विज'"}</span>
                            <br />
                            में भाग लेकर बूथ संख्या <span className="span_content">{boothDetails.boothno}</span>, <span className="span_content">{boothDetails.vsabha}</span> <br />
                            विधानसभा क्षेत्र, <span className="span_content">{boothDetails.state} </span>को, गौरवान्वित किया है।
                        </h6>

                        {isScoreShow && <p className="yougot_hi">
                            आपने{" "}
                            <span className="span_content">{score} </span>प्रश्नो का सही उत्तर दिया है।
                        </p>}
                        <h5 className="certi_canvs_h52_hi">क्विज प्रतियोगिता मैं हिस्सा लेने के लिए धन्यवाद। </h5>
                        <h4 className="app_txt_hi">नमो एप</h4>
                    </div>
                </div>

            </div>
        )
    } else {
        return (
            <div className="cert_center" id="generate_canvas_div">

                <div className="cert_content_position">
                    <div className="cert_content">
                        <img src="/assets/images/modi.png" alt="" />

                        <h5 className="nm_can_name">
                            Narendra <span>Modi</span>
                        </h5>

                        <h2 className="cong_canvas_hi">बधाई हो </h2>
                        <h3 className="volnt_name_hi_nor">
                            {user ? user : "Guest"}
                        </h3>
                        <h6 className="volnt_g_eff_hi_nor">बहुत ही सराहनीये प्रयास!</h6>
                        <h2 className="mkb_qz_h2_hi_nor">{title || "'मन की बात क्विज'"}</h2>
                        {isScoreShow && <p className="yougot_hi_nor">
                            प्रतियोगिता में आपने{" "}<span>{score}</span> प्रश्नो का सही उत्तर दिया है।
                        </p>}
                        <h5 className="certi_canvs_h5_hi_nor">आपकी भागीदारी प्रशंसनीय है!</h5>
                        <h5 className="certi_canvs_h52_h1_nor">क्विज प्रतियोगिता मैं भाग लेने के लिए धन्यवाद!</h5>
                        <h4 className="app_txt_hi_nor">नमो एप </h4>
                    </div>
                </div>
            </div>
        )
    }

}